export function isSameMonth(date1, date2) {
  return (
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
}
export function isSameDay(date1, date2) {
  const x = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const y = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  return x.valueOf() === y.valueOf();
}
export function toUTC(date) {
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
}
export function UTCReady(date) {
  const readyDate = new Date(date);
  readyDate.setMinutes(readyDate.getMinutes() - readyDate.getTimezoneOffset());
  return readyDate;
}
export function getFirstLastDay(date) {
  var fromDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0);
  var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59);

  return { fromDate, toDate };
}
export function getDaysInMonth(date) {
  date = new Date(date);
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}
export function isWeekAgo(date) {
  if (!date) return true;
  const diffTime = Math.abs(date - new Date());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays >= 7) return true;
  else return false;
}
export function isDateBeforeDate(date1, date2) {
  const d1 = typeof date1.toDateString === 'function' ? date1 : new Date(date1);
  const d2 = typeof date2.toDateString === 'function' ? date2 : new Date(date2);
  return new Date(d1.toDateString()) < new Date(d2.toDateString());
}
export function getDateUTC() {
  const date = new Date();

  // date.setUTCHours(0, 0, 0, 0)
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
}
export function formatDate(date, withDay, separator = '-', isReversed) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  const res = withDay ? [day, month, year] : [month, year];
  return isReversed ? res.reverse().join(separator) : res.join(separator);
}

export function getEraDate(date, eraNum) {
  date = new Date(date);
  var fromDate = new Date();
  var toDate = new Date();
  fromDate.setMonth(date.getMonth());
  toDate.setMonth(date.getMonth());
  if (eraNum === 1) {
    fromDate.setDate(1);
    toDate.setDate(15);
  } else if (eraNum === 2) {
    fromDate.setDate(16);
    toDate.setDate(getDaysInMonth(toDate));
  }
  fromDate.setHours(0, 0, 0, 0);
  toDate.setHours(23, 59, 59, 50);
  return {
    fromDate,
    toDate,
  };
}
